import { Stack, styled } from "@mui/material";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useKycList } from "@/hooks/use-kyc-list";
import CustomSearchInput from "@/components/custom/custom-search-input";
import CustomSelectInput from "@/components/custom/custom-select-input";
import { DataTable } from "@/components/custom/data-table";
import CustomPagination from "@/components/custom/custom-pagination";
import { getKycColumns } from "./_components/kyc-columns";

const SectionRoot = styled("section")(({ theme }) => ({
  // margin: theme.spacing(2),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const Card = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: "16px 20px",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

const KycLists = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()

  const searchValue = searchParams.get("search") || "";
  const currentPage = Number(searchParams.get("page") || 0);
  const pageSize = Number(searchParams.get("size") || 10);

  const approvalStatus = searchParams.get("approvalStatus");
  const businessType = searchParams.get("businessType");
  const order = searchParams.get("order");

  const queryParams = {
    page: currentPage + 1,
    size: pageSize,
    order: order || "DESC",
    approvalStatus: approvalStatus || undefined,
    businessType: businessType || undefined,
    search: searchValue,
  };

  const { data, isLoading, isError } = useKycList(true, queryParams);

  function handleView(userId) {
    navigate(`/kyc/business-kyc/${userId}`)
  }

  return (
    <SectionRoot>
      <Card>
        <Stack
          direction={"row"}
          spacing={3}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction={"row"} spacing={3}>
            <CustomSearchInput
              paramKey="search"
              placeholder="Search kyc..."
            />
            <CustomSelectInput
              paramKey="order"
              label="Order"
              placeholder="Order"
              options={[
                { label: "Descending", value: "DESC" },
                { label: "Ascending", value: "ASC" },
              ]}
            />
          </Stack>
        </Stack>

        <DataTable
          columns={getKycColumns()}
          data={data?.data?.content ?? []}
          isLoading={isLoading}
          isError={isError}
          onRowClick={(row) => handleView(row.merchantId)}
        />
        <CustomPagination
          total={data?.data?.totalElements ?? 0}
          perPageOptions={[5, 10, 20, 50, 100]}
        />
      </Card>
    </SectionRoot>
  );
};

export default KycLists;
